<form [ngClass]="{'pending': pending === true}" [formGroup]="form" (submit)="submit()">
  <h1>Inscription</h1>
  <label>Inscription via un code personnel</label>
  <small class="alert-danger p-4 mb-2" *ngIf="error">
    {{error.message}}
  </small>
  <div class="p-4 bg-light">

    <spaq-input-text name="companyCode" label="Code de l'organisme" [form]="form"></spaq-input-text>
    <spaq-input-text name="userCode" label="Code personnel" [form]="form"></spaq-input-text>


  <button [primary]="true" kendoButton class="w-100 mt-4" type="submit">Continuer</button>
  <a class="d-block w-100 mt-4 cta" routerLink="/auth/login/email">Retour au formulaire de connexion</a>
  </div>
</form>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/components/register-code/register-code.component.html